export enum ServiceInvoiceStatus {
  PAID = "paid",
  FAILED = "failed",
  PAYMENT_PENDING = "payment_pending",
}

export const DEFAULT_SERVICE_INVOICE_STATUSES: readonly ServiceInvoiceStatus[] =
  [ServiceInvoiceStatus.FAILED];
